import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-6">
            <img
              src="https://customer-assets.emergentagent.com/job_barnett-auto-detail/artifacts/j4o56dv7_E59AF405-589D-41F4-8F13-5979ECF507B0.png"
              alt="Barnett Auto Detailing logo"
              className="w-40 sm:w-48 h-auto mb-6"
            />
            <div className="font-display font-black text-4xl sm:text-6xl tracking-tighter leading-none">
              BARNETT<span className="text-[#E63946]">.</span>
            </div>
            <div className="section-label mt-3">Auto Detailing · Tampa, FL</div>
            <p className="mt-6 text-zinc-400 max-w-md leading-relaxed">
              Showroom-grade mobile detailing — interior, exterior, and premium full
              service. We bring everything to you.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="section-label mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li>
                <a href="tel:8134818875" data-testid="footer-phone" className="flex items-center gap-2 hover:text-white">
                  <Phone className="w-4 h-4 text-[#E63946]" /> 813-481-8875
                </a>
              </li>
              <li>
                <a href="mailto:barnettautodetailingllc@gmail.com" data-testid="footer-email" className="flex items-center gap-2 hover:text-white break-all">
                  <Mail className="w-4 h-4 text-[#E63946] shrink-0" /> barnettautodetailingllc@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-[#E63946]" /> Tampa, FL &amp; Surrounding
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="section-label mb-4">Hours</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li className="flex justify-between"><span>Mon – Sat</span><span>9 – 5</span></li>
              <li className="flex justify-between"><span>Sunday</span><span>Closed</span></li>
            </ul>

            <div className="mt-6 flex items-center gap-3">
              <a
                data-testid="footer-instagram"
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/10 hover:border-[#E63946] hover:text-[#E63946] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                data-testid="footer-facebook"
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/10 hover:border-[#E63946] hover:text-[#E63946] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} Barnett Auto Detailing. All rights reserved.</span>
          <span>Mobile detailing services in Tampa, FL.</span>
        </div>
      </div>
    </footer>
  );
}
